import { Column, Row } from "components/styles";
import { TextData, Title } from "views/components/Schedules/components/UpdateActivityPopup/styles";
import ResourceData from "./components/ResourceData/ResourceData";
import ReservationDurationData from "views/components/Schedules/components/UpdateActivityPopup/components/ReservationDurationData";
import LocationIcon from "icons/LocationIcon";
import MessageIcon from "icons/MessageIcon";
import { getTimeParts } from "components/CustomTimePicker/utils";
import { FieldIconWrapper } from "views/components/Schedules/styles";

const InformationBlock = ({
    title, 
    details,
    location: {
        campus, library
    },
    schedule: {
        date, timeStart, timeEnd
    },
    resource
}) => {
    const duration = {
        date,
        timeParts: {
            start: getTimeParts(timeStart), 
            end: getTimeParts(timeEnd)
        }
    };
    return (
        <Column gap="6px">
            <Title title={title}>{title}</Title>
            {details &&
            <Row wrap="nowrap" gap="10px" width="100%">
                <FieldIconWrapper>
                    <MessageIcon/>
                </FieldIconWrapper>
                <TextData 
                    className="ellipsis" 
                    title={details}>
                    {details}
                </TextData>
            </Row>}
            <ReservationDurationData duration={duration} gap="10px"/>
            <Row 
                width="100%" 
                gap="10px" 
                justifyContent="flex-start">
                <FieldIconWrapper>
                    <LocationIcon/>
                </FieldIconWrapper>
                <Column width="max-content" gap="6px">
                    <TextData weight="bold">{campus}</TextData>
                    <TextData>{library}</TextData>
                </Column>
            </Row>
            <ResourceData resource={resource}/>
        </Column>
    );
}

export default InformationBlock;